import { defineStore } from 'pinia';
import { type LoginInfo } from '~/types';

export const useProfileLoginStore = defineStore('profileLoginStore', () => {
  const loginStatus = ref<LoginInfo>({
    isLoggedIn: false,
    username: '',
    firstName: '',
    lastName: '',
    ncpIdHash: '',
    products: [],
    isSubscriber: false,
    isTotalSubscriber: false,
    brazeId: '',
    oneId: ''
  });

  const companyLogin = ref({
    access: false,
    adminLink: '',
    adminLinkText: ''
  });

  function setLoginStatus (status: LoginInfo) {
    loginStatus.value = status;
  }

  function setCompanyLogin (value: { access: boolean; adminLink: string; adminLinkText: string }) {
    companyLogin.value = value;
  }
  return {
    loginStatus,
    companyLogin,
    setLoginStatus,
    setCompanyLogin
  };
});
